import React, { useEffect, useState } from "react";
import "../styles/news.css";
import axios from "../axios";
import { Link } from "react-router-dom";

function News() {
  const [news, setNews] = useState([]);

  useEffect(async () => {
    const result = await axios.get("/news");

    const reversedArray = reverseArray(result.data);
    setNews(reversedArray);
  }, []);

  const reverseArray = (array) => {
    let reversedArray = array.slice(0).reverse();
    return reversedArray;
  };

  return (
    <div className="news">
      <div className="borders">
        <div className="news__container">
          <div className="news__title">Haberler</div>
          {news &&
            news.map((item) => (
              <div className="news__item">
                <div className="news__itemContainer">
                  <div className="news__itemHeader">
                    <h5 className="news__itemTitlle">{item.title}</h5>
                    <span className="news__itemDate">{item.date}</span>
                  </div>
                  <p className="news__itemNews">
                    {item.news.slice(0, 90)}...{" "}
                    <Link
                      to={{ pathname: "/fullNews", state: { item } }}
                      className="newsLink"
                    >
                      devamı
                    </Link>
                  </p>
                </div>
              </div>
            ))}
        </div>
        <div className="topLeftBorder">
          <div>
            <div className="borderTop"></div>
            <div className="borderLeft"></div>
          </div>
        </div>
        <div className="bottomRigtBorder">
          <div>
            <div className="borderRight"></div>
            <div className="borderBottom"></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default News;
